export interface Publisher {
	name: string;
	events: PublisherItem[];
	selectAll: boolean;
	selectedItems: any[];
}
export interface PublisherItem {
	uuid: string;
	merchantId: number;
	eventId: string;
	eventType: string;
	eventSource: string;
	eventStatus: string;
	eventSourceId: string;
	eventSourceName: string;
	eventDetails: string;
	createdDate: string;
	updatedDate: string;
	createdBy: string;
	errorCode: string;
	errorMessage: string;
	disabled:boolean;
	checked:boolean;
	dependencyMap:[key: string, string];
	lowerMerchantId:string;
}
export const PublisherKeys: Record<string, string> = {
	ACCOUNT: "Accounts",
	CATALOG: "Card Catalog",
	SCHEDULE: "Schedules",
	USER: "Users",
	TEMPLATE: "Templates",
	STORE: "Storefront Configuration",
	PROMOTION: "Promotions",
	BRAND: "Brand Management",
	INTERNAL_ORDERING: "Internal Ordering",
};
export const PrivilegeKey: Record<string, string> = {
	ACCOUNT: "Publisher_Accounts",
	CATALOG: "Publisher_Catalog",
	SCHEDULE: "Publisher_Schedule",
	USER: "Publisher_Users",
	TEMPLATE: "Publisher_Templates",
	STORE: "Publisher_Stores",
	PROMOTION: "Publisher_Promotions",
	BRAND: "Publisher_Brand",
	// INTERNAL_ORDERING: "Publisher_Internal_Ordering",
	INTERNAL_ORDERING: "Publisher_Users",

};
export interface PublishItemPayload {
	uuid: string;
}
